
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/copyright",
      function () {
        return require("private-next-pages/terms/copyright.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/copyright"])
      });
    }
  